import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from '@dnd-kit/utilities';
import { Icon, IconButton } from "@fluentui/react";
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { useStyles } from "./PickerListItem.styles";

initializeIcons();

interface PickerListItemProps {
  id: string;
  label: string;
  onDeleteClick: () => void;
}

export const PickerListItem: React.FC<PickerListItemProps> = (props) => {
  const {id, label, onDeleteClick} = props;

  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transition,
    transform,
  } = useSortable({id});

  const classes = useStyles();

  return (
    <div
      ref={setNodeRef}
      style={{transition, transform: CSS.Transform.toString(transform)}}
      className={classes.pickerListItem}
    >
      <div {...listeners} {...attributes} className={classes.dndGrip} ref={setActivatorNodeRef}>
        <Icon iconName='GripperDotsVertical'/>
      </div>
      <div className={classes.label}>{label}</div>
      <IconButton
        onClick={() => onDeleteClick()}
        iconProps={{iconName: 'Cancel', style: {fontSize: '16px'}}}
        className='deleteButton'
      />
    </div>
  )
}
